import { DividerContainer, DividerContent, DividerElement } from './style';

export type DividerDirection = 'vertical' | 'horizontal';
export type BorderStyle = 'solid' | 'dotted';
export type DividerSize = 'default' | 'large';

type DividerProps = {
    children?: React.ReactNode;
    direction?: DividerDirection;
} & ({ size: DividerSize; borderStyle?: Extract<BorderStyle, 'solid'> } | { size?: never; borderStyle?: BorderStyle });

export const Divider = ({
    children,
    size = 'default',
    direction = 'horizontal',
    borderStyle = 'solid',
    ...other
}: DividerProps) => (
    <DividerContainer direction={direction} {...other} role="separator" aria-orientation={direction}>
        <DividerElement direction={direction} size={size} borderStyle={borderStyle} />
        {children ? (
            <>
                <DividerContent>{children}</DividerContent>
                <DividerElement direction={direction} size={size} borderStyle={borderStyle} />
            </>
        ) : null}
    </DividerContainer>
);
